import { Button, CircularProgress } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

interface LoadingButtonProps {
  loading: boolean;
  onClickAction: () => void;
  width?: string;
}

const LoadingButton = ({
  loading,
  onClickAction,
  width = "200px",
}: LoadingButtonProps) => {
  return (
    <Button
      disabled={loading}
      aria-label="add data from overpassTurbo"
      variant="contained"
      onClick={onClickAction}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: width,
        }}
      >
        {loading ? (
          <CircularProgress style={{ width: "24px", height: "24px" }} />
        ) : (
          <AutoAwesomeIcon />
        )}
        <div>Search</div>
      </div>
    </Button>
  );
};

export default LoadingButton;
